import React, { useState as _useState } from 'react';
import { Button } from '@mui/material';

interface IData {
    [key: string]: any;
}

const SportModeButton: React.FC<IData> = (props) => {
    const { setInfo, info, setDefaultValues } = props;

    const handleSportMode = () => {
        setDefaultValues((prev: any) => ({ ...prev,
            isgrouping_eq: !info.sportmode,
            exclude_zone_eq: !info.sportmode ? null : prev.exclude_zone_eq === true ? true : false,
            exclude_sport_eq: !info.sportmode ? null : prev.exclude_sport_eq === true ? true : false }));
        setInfo((prev: any) => ({
            ...prev, sportmode: !info.sportmode,
            title: !info.sportmode ? 'Sports Analysis Page' : 'Order Detail Analysis'
        }));
    };
    return (
        <Button onClick={handleSportMode}
            color={info.sportmode ? 'success' : 'info'}
            variant={info.sportmode ? 'contained' : 'outlined'}
        >SPORT: {info.sportmode ? 'ON' : 'OFF'}</Button>
    );
};
export default React.memo(SportModeButton);
